/**
 * Локальные настройки кабинета — аналог GameSettings.kt.
 * На вебе все настройки хранятся в localStorage (деплой не нужен).
 *
 * Большинство настроек влияют только на игровой клиент (apk/exe), на сайте
 * они хранятся «на будущее» — синхронизируются с приложением через общий
 * аккаунт. Дефолты — те же, что в Android.
 */

const KEY = "rublox_game_settings";

const DEFAULTS = {
  cameraSensitivity: 5,
  cameraView: "third", // third | first
  invertCameraY: false,
  graphicsQuality: 7,
  showFps: false,
  reducedMotion: false,
  volume: 8,
  chatSound: true,
  chatWho: "all", // all | friends | nobody
  disableChat: false,
  showOnlineStatus: true,
  showCurrentGame: true,
  notifyMessages: true,
  notifyAchievements: true,
  notifyFriendInvites: true,
  notifyNews: true,
  doNotDisturb: false,
  maxAgeRating: 18,
  dailyTimeLimitMin: 0,
};

export function loadSettings() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(settings) {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    /* приватный режим */
  }
}
